export type AppErrorCode =
  | (string & {})
  | "ERROR"
  | "VALIDATION_ERROR"
  | "SYSTEM_ERROR"
  | "UNEXPECTED_ERROR"
  | "UNKNOWN_ERROR";

//

export interface AppErrorOptions<TData> {
  isOperational?: boolean;
  statusCode?: number;
  code?: AppErrorCode;
  data?: TData;
}

//

export class AppError<TData = unknown> extends Error {
  public statusCode: number; // HTTP-статус код ошибки
  public isOperational?: boolean; // Операционная ошибка (ожидаемая) или нет
  public data?: TData;
  private _code?: AppErrorCode;

  constructor(
    message: string,
    { statusCode = 500, isOperational, code, data }: AppErrorOptions<TData> = {},
  ) {
    super(message);
    this.name = "AppError";

    Object.setPrototypeOf(this, new.target.prototype);
    this.statusCode = statusCode;
    this.isOperational = isOperational;
    this.data = data;
    this._code = code;

    Error.captureStackTrace(this, AppError);
  }

  //

  public get code() {
    return this._code || this.name;
  }
}
